import Chart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { SkillStatusHeading } from "../../../Constant";
import { RADIAL_CHART_LIVE } from "../../../Data/Widgets/ChartWidgets";

const SkillStatus = () => {
  return (
    <Col xl="6" lg="12" className="box-col-6 xl-50">
      <Card>
        <CommonCardHeader title={SkillStatusHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container skill-chart">
            <div id="circlechart">
              <Chart options={RADIAL_CHART_LIVE} series={RADIAL_CHART_LIVE.series} height="350" type="radialBar"/>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SkillStatus;
